import Colors from '../../utils/colors'

export const CustomButton = ({ 
  children, 
  variant = 'filled', 
  color = Colors.primary,
  width = '100%',
  height = 28,
  borderRadius = 8,
  fontSize = 14,
  fontWeight = 600,
  disabled = false,
  className = '',
  style = {},
  ...props 
}) => {
  const baseStyles = {
    width,
    height: `${height}px`,
    borderRadius: `${borderRadius}px`,
    fontSize: `${fontSize}px`,
    fontWeight,
    padding: '0 8px',
    border: `1px solid ${disabled ? Colors.lightGray : (style.borderColor || color)}`,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'all 0.3s ease',
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  }

  const currentColor = disabled ? Colors.lightGray : (style.backgroundColor || color)
  const currentBorderColor = disabled ? Colors.lightGray : (style.borderColor || color)
  const currentTextColor = disabled ? Colors.lightGray : (style.color || (variant === 'filled' ? 'white' : color))

  const filledStyles = {
    backgroundColor: currentColor,
    color: variant === 'filled' ? 'white' : currentTextColor,
    borderColor: currentBorderColor
  }

  const outlineStyles = {
    backgroundColor: 'transparent',
    color: currentTextColor,
    borderColor: currentBorderColor
  }

  const hoverStyles = variant === 'filled' 
    ? { backgroundColor: Colors.secondary, borderColor: Colors.secondary }
    : { backgroundColor: currentColor, color: 'white' }

  return (
    <button
      className={className}
      disabled={disabled}
      style={{
        ...baseStyles,
        ...(variant === 'filled' ? filledStyles : outlineStyles),
        ...style
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          Object.assign(e.target.style, hoverStyles)
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          const resetStyles = variant === 'filled' ? filledStyles : outlineStyles
          Object.assign(e.target.style, { ...resetStyles, ...style })
        }
      }}
      {...props}
    >
      {children}
    </button>
  )
}